import { render, staticRenderFns } from "./Player2.vue?vue&type=template&id=3c0d2eb6&scoped=true&"
import script from "./Player2.vue?vue&type=script&lang=js&"
export * from "./Player2.vue?vue&type=script&lang=js&"
import style0 from "./Player2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Player2.vue?vue&type=style&index=1&id=3c0d2eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0d2eb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSlider})
